import { useMemo } from 'react';
import { getLocale } from 'rcm-i18n';

const numberFormatOptions = {
  'en-GB': {
    style: 'currency',
    currency: 'GBP',
  },
  'de-DE': {
    style: 'currency',
    currency: 'EUR',
  },
  'fr-FR': {
    style: 'currency',
    currency: 'EUR',
  },
  'nl-NL': {
    style: 'currency',
    currency: 'EUR',
  },
  default: {
    style: 'currency',
    currency: 'USD',
  },
};

/**
 * Calculate updated price with VAT.
 * @param price String represented price
 * @param vatAmount Calculated additional VAT from vista to add to price. defaults to 0
 * @returns Price with VAT applied
 * @example vatCalculator('€63.00', 12.60) // €75.60
 */
const useVatCalculator = (price: string, vatAmount = 0) => {
  const locale = getLocale().replace('_', '-');

  const combinedPrice = useMemo(() => {
    const justDigits = Number(price.replace(/\D/g, '')) / 100;

    const newPrice = Number(justDigits + vatAmount);

    return new Intl.NumberFormat(
      locale,
      numberFormatOptions[locale] ?? numberFormatOptions.default
    ).format(newPrice);
  }, [vatAmount, price, locale]);

  return combinedPrice;
};

export default useVatCalculator;
